var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BigNumber } from "ethers";
import { useContext } from "react";
import { isSolanaVault, VaultAddressMap, VaultList, VaultVersionList, } from "../constants/constants";
import { SubgraphDataContext } from "./subgraphDataContext";
var getVaultAccountKey = function (vault) {
    return "vaultAccount_" + vault.replace(/-/g, "");
};
export var vaultAccountsGraphql = function (_account, version) {
    return VaultList.reduce(function (acc, vault) {
        var vaultAddress = VaultAddressMap[vault][version];
        var account = "" + _account;
        if (!vaultAddress) {
            return acc;
        }
        if (!isSolanaVault(vault)) {
            vaultAddress = vaultAddress.toLowerCase();
            account = _account.toLowerCase();
        }
        return (acc +
            ("\n          " + getVaultAccountKey(vault) + ": vaultAccount(id:\"" + vaultAddress + "-" + account + "\") {\n            totalDeposits\n            totalYieldEarned\n            totalBalance\n            totalStakedBalance\n            totalStakedShares\n            " + (version !== "v1" ? "totalPendingDeposit" : "") + "\n            vault {\n              symbol\n            }\n          }\n        "));
    }, "");
};
export var resolveVaultAccountsSubgraphResponse = function (responses) {
    return Object.fromEntries(VaultVersionList.map(function (version) { return [
        version,
        Object.fromEntries(VaultList.map(function (vault) {
            var data = responses[version]
                ? responses[version][getVaultAccountKey(vault)]
                : undefined;
            if (!data) {
                return [vault, undefined];
            }
            return [
                vault,
                __assign(__assign({}, responses[version][getVaultAccountKey(vault)]), { totalDeposits: BigNumber.from(responses[version][getVaultAccountKey(vault)].totalDeposits), totalYieldEarned: BigNumber.from(responses[version][getVaultAccountKey(vault)].totalYieldEarned), totalBalance: BigNumber.from(responses[version][getVaultAccountKey(vault)].totalBalance), totalStakedShares: responses[version][getVaultAccountKey(vault)]
                        .totalStakedShares
                        ? BigNumber.from(responses[version][getVaultAccountKey(vault)]
                            .totalStakedShares)
                        : BigNumber.from(0), totalStakedBalance: responses[version][getVaultAccountKey(vault)]
                        .totalStakedBalance
                        ? BigNumber.from(responses[version][getVaultAccountKey(vault)]
                            .totalStakedBalance)
                        : BigNumber.from(0), totalPendingDeposit: responses[version][getVaultAccountKey(vault)]
                        .totalPendingDeposit
                        ? BigNumber.from(responses[version][getVaultAccountKey(vault)]
                            .totalPendingDeposit)
                        : BigNumber.from(0) }),
            ];
        })),
    ]; }));
};
export var useAllVaultAccounts = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        data: contextData.vaultSubgraphData.vaultAccounts,
        loading: contextData.vaultSubgraphData.loading,
    };
};
var useVaultAccounts = function (variant) {
    var contextData = useContext(SubgraphDataContext);
    switch (variant) {
        case "all":
            return {
                vaultAccounts: Object.fromEntries(VaultList.map(function (vault) { return [
                    vault,
                    VaultVersionList.reduce(function (acc, version) {
                        var currentVersionVaultAccount = contextData.vaultSubgraphData.vaultAccounts[version][vault];
                        if (!acc) {
                            return currentVersionVaultAccount;
                        }
                        if (!currentVersionVaultAccount) {
                            return acc;
                        }
                        return __assign(__assign({}, acc), { totalDeposits: acc.totalDeposits.add(currentVersionVaultAccount.totalDeposits), totalYieldEarned: acc.totalYieldEarned.add(currentVersionVaultAccount.totalYieldEarned), totalBalance: acc.totalBalance.add(currentVersionVaultAccount.totalBalance), totalStakedShares: acc.totalStakedShares.add(currentVersionVaultAccount.totalStakedShares), totalStakedBalance: acc.totalStakedBalance.add(currentVersionVaultAccount.totalStakedBalance) });
                    }, undefined),
                ]; })),
                loading: false,
            };
        default:
            return {
                vaultAccounts: contextData.vaultSubgraphData.vaultAccounts[variant],
                loading: contextData.vaultSubgraphData.loading,
            };
    }
};
export default useVaultAccounts;
//# sourceMappingURL=useVaultAccounts.js.map